import styled from "@emotion/styled";
import { PageHeader } from "../../AccountPage/components/PageHeader"
import NewsList from "../components/NewsList";
const NewsContainer = styled.div`
    width: 100%;
    height: 100vh;
    
    background: linear-gradient(0deg, #EBF3FF, #ffebf7),
radial-gradient(136.79% 100% at 100% 0%, rgba(255, 184, 219, 0.5) 0%, rgba(255, 255, 255, 0) 100%),
radial-gradient(100% 61.68% at 0% 100%, rgba(179, 255, 204, 0.25) 0%, rgba(255, 255, 255, 0) 100%);

`

export default function New(){
    return(
        <NewsContainer>
            <PageHeader
                title="News"
                backPath="/my"
                iconType="black-arrow"
                textColor="#131416"
                backgroundColor="transparent"
            />
            <NewsList></NewsList>
        </NewsContainer>
    )
}